var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMenuBento = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 27,
  fill: "none",
  "data-coloringtype": "fill",
  viewBox: "0 0 28 27"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M9.454 14.779a3.286 3.286 0 1 1 0 6.572 3.286 3.286 0 0 1 0-6.572m8.762 0a3.286 3.286 0 1 1 0 6.572 3.286 3.286 0 0 1 0-6.572M9.454 6.017a3.286 3.286 0 1 1 0 6.573 3.286 3.286 0 0 1 0-6.573m8.762 0a3.286 3.286 0 1 1 0 6.573 3.286 3.286 0 0 1 0-6.573"
})));
export default SvgMenuBento;